export default __webpack_public_path__ + "static/image150-06e4b95af9e36130ee252d28bdcadab9.jpg";